const ENTRY_FORM_FIELDS = `
  id
  contact_id
  contact { id firstname lastname email }
  responsible_id
  responsible { id firstname lastname }
  group_id
  group { id name }
  status_id
  entry_form_status { id name hex_color }
  program_id
  program { id name }
  variant_id
  program_variant { id name }
  date_from
  prospect_email
  company_name
  bill_type
  payment_type
  special_payment_method
  authorizations
  installment_payment
  is_reentry
  referred_by
  referred_by_type
  referred_by_other
  referred_by_counselor
  referred_by_event
  referred_by_free_text
  is_lead
  is_gdi
  signature
  comments
  its
  uts
  bank_account_owner
  bank_account_cbu
  bank_account
  bank_account_number
  card_type
  card_number
  card_due_date
  industry
  employees
  income
  company_type
  pdf
  custom_monthly_fee
  custom_signup
  entry_form_benefit {
    id
    benefit_id
    benefit {
      id
      name
      company_number
      monthly_fee_discount
      signup_discount
      active
    }
  }
`;

export const CREATE_ENTRY_FORM = `
  mutation createEntryForm($input: CreateEntryFormInput!, $tenant_id: Int!) {
    createEntryForm(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on EntryForm {
        ${ENTRY_FORM_FIELDS}
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const EDIT_ENTRY_FORM = `
  mutation editEntryForm($input: EditEntryFormInput!, $tenant_id: Int!) {
    editEntryForm(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on EntryForm {
        ${ENTRY_FORM_FIELDS}
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_ENTRY_FORM = `
  mutation deleteEntryForm($id: Int!, $tenant_id: Int!) {
    deleteEntryForm(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on EntryForm {
        id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const REQUEST_ENTRY_FORMS = `
  mutation requestEntryForms($input: EntryFormIdsInput!, $tenant_id: Int!) {
    requestEntryForms(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on EntryForm {
        id
        status_id
        entry_form_status { id name hex_color }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const CANCEL_ENTRY_FORMS = `
  mutation cancelEntryForms($input: EntryFormIdsInput!, $tenant_id: Int!) {
    cancelEntryForms(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on EntryForm {
        id
        status_id
        entry_form_status { id name hex_color }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const APPROVE_ENTRY_FORM = `
  mutation approveEntryForm($input: EntryFormIdInput!, $tenant_id: Int!) {
    approveEntryForm(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on EntryForm {
        id
        status_id
        entry_form_status { id name hex_color }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const FINALIZE_ENTRY_FORM = `
  mutation finalizeEntryForm($input: EntryFormIdInput!, $tenant_id: Int!) {
    finalizeEntryForm(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on EntryForm {
        id
        status_id
        entry_form_status { id name hex_color }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const CONFIRM_ENTRY_FORM = `
  mutation confirmEntryForm($input: EntryFormIdInput!, $tenant_id: Int!) {
    confirmEntryForm(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on EntryForm {
        id
        status_id
        entry_form_status { id name hex_color }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const MARK_PROCESSED_ENTRY_FORM = `
  mutation markProcessedEntryForm($input: EntryFormIdInput!, $tenant_id: Int!) {
    markProcessedEntryForm(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on EntryForm {
        id
        status_id
        entry_form_status { id name hex_color }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const CHANGE_ENTRY_FORM_STATUS = `
  mutation changeEntryFormStatus($input: ChangeEntryFormStatusInput!, $tenant_id: Int!) {
    changeEntryFormStatus(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on EntryForm {
        id
        status_id
        entry_form_status { id name hex_color }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const LOAD_ENTRY_FORM = `
  mutation loadEntryForm($input: EntryFormIdInput!, $tenant_id: Int!) {
    loadEntryForm(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on EntryForm {
        id
        status_id
        entry_form_status { id name hex_color }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPLOAD_ENTRY_FORM_SIGNATURE = `
  mutation uploadEntryFormSignature($id: Int!, $tenant_id: Int!, $file: Upload!) {
    uploadEntryFormSignature(id: $id, tenant_id: $tenant_id, file: $file) {
      __typename
      ... on EntryForm {
        id
        signature
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPLOAD_ENTRY_FORM_AUTHORIZATION = `
  mutation uploadEntryFormAuthorization($id: Int!, $tenant_id: Int!, $file: Upload!) {
    uploadEntryFormAuthorization(id: $id, tenant_id: $tenant_id, file: $file) {
      __typename
      ... on EntryForm {
        id
        authorizations
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const SAVE_ENTRY_FORM_DRAFT = `
  mutation saveEntryFormDraft($token: String!, $input: SubmitEntryFormInput!) {
    saveEntryFormDraft(token: $token, input: $input) {
      __typename
      ... on EntryForm {
        id
        status_id
        entry_form_status { id name hex_color }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const SUBMIT_ENTRY_FORM = `
  mutation submitEntryForm($token: String!, $input: SubmitEntryFormInput!) {
    submitEntryForm(token: $token, input: $input) {
      __typename
      ... on EntryForm {
        id
        status_id
        entry_form_status { id name hex_color }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPLOAD_ENTRY_FORM_SIGNATURE_BY_TOKEN = `
  mutation uploadEntryFormSignatureByToken($token: String!, $file: Upload!) {
    uploadEntryFormSignatureByToken(token: $token, file: $file) {
      __typename
      ... on EntryForm {
        id
        signature
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
